import React from "react";

const CancelIcon = () => {
  return (
    <svg
      width="29.75"
      height="29.75"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M29.4433 0L14.8748 14.569L0.305769 0L0 0.305769L14.569 14.8748L0 29.4438L0.305769 29.7496L14.8748 15.1806L29.4433 29.7496L29.749 29.4438L15.1806 14.8748L29.749 0.305769L29.4433 0Z"
        fill="#353535"
      />
    </svg>
  );
};

export default CancelIcon;
